<script lang="ts">
    import type { RichWordlist } from "@app/models/api";
    import { setWordlist, similarPhrases, wordlist, type WordlistState } from "../Search.store";
    import SidebarWordlist from "../SidebarWordlist.svelte";
    import SidebarSimilarList from "../SidebarSimilarList.svelte";

    const sidebarWordlistContainer =
        document.getElementById("sidebar-wordlist");
    if (sidebarWordlistContainer) {
        // initialize list
        const currentWordlist: RichWordlist = {
            before: [],
            after: [],
            success: true,
        };
        let activeItem: number | undefined;
        [
            ...sidebarWordlistContainer.querySelectorAll(
                "li:not([data-empty=true])"
            ),
        ].forEach((wordlistItemContainer, index) => {
            const text = wordlistItemContainer.querySelector("*").textContent;
            if (wordlistItemContainer.classList.contains("active")) {
                activeItem = index;
            }
            currentWordlist.after.push({ phrase: text });
        });

        setWordlist(currentWordlist, true, activeItem);
        /*
        wordlist.subscribe((wordlistVal: WordlistState) => {
            if (wordlistVal.isLazy) {
                return;
            } else {
                if (
                    sidebarWordlistContainer &&
                    !(sidebarWordlistContainer as any).sidebarWordlist
                ) {
                    const sidebarWordlist = new SidebarWordlist({
                        target: sidebarWordlistContainer.parentElement,
                    });
                    sidebarWordlistContainer.parentElement.removeChild(
                        sidebarWordlistContainer
                    );

                    (sidebarWordlistContainer as any).sidebarWordlist =
                        sidebarWordlist;
                }
            }
        });*/
        let installed = false;
        similarPhrases.subscribe(similarPhrasesVal => {
            if (similarPhrasesVal.isLazy || installed) {
                return;
            } else {
                installed = true;
                if (
                    sidebarWordlistContainer &&
                    !(sidebarWordlistContainer as any).sidebarSimilarList
                ) {
                    const sidebarSimilarList = new SidebarSimilarList({
                        target: sidebarWordlistContainer.parentElement,
                    });
                    sidebarWordlistContainer.parentElement.removeChild(
                        sidebarWordlistContainer
                    );

                    (sidebarWordlistContainer as any).sidebarSimilarList =
                    sidebarSimilarList;
                }
            }


        })
    }
</script>
